module.exports = __webpack_public_path__ + "img/hero2x.1ee55232.webp";